import { apiSlice } from "../../app/api/apiSlice";

export const galleryApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getGalleryPhotos: builder.query({
      query: () => "/gallery",
      providesTags: ["Gallery"],
    }),
    uploadGalleryPhoto: builder.mutation({
      query: (formData) => ({
        url: "/gallery",
        method: "POST",
        body: formData, // Form data carries strings + raw file chunks combined
      }),
      invalidatesTags: ["Gallery"],
    }),
    updateGalleryPhoto: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/gallery/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["Gallery"],
    }),
    deleteGalleryPhoto: builder.mutation({
      query: (id) => ({
        url: `/gallery/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Gallery"],
    }),
  }),
});

export const {
  useGetGalleryPhotosQuery,
  useUploadGalleryPhotoMutation,
  useUpdateGalleryPhotoMutation,
  useDeleteGalleryPhotoMutation,
} = galleryApiSlice;
